type ConsentCategory = 'strict' | 'performance' | 'functionality' | 'targeting';

export type ConsentState = {
  action?: string;
  categories?: Array<ConsentCategory>;
};

export const CONSENT_MSG = 'racemap-cookie-consent';
export const CONSENT_REQUEST_MSG = 'racemap-cookie-consent-request';

const ALLOWED_PARENTS: ReadonlyArray<string> = ['https://go.racemap.com', 'https://racemap.com'];

export function listenForChildRequests(getConsent: () => ConsentState | null): void {
  window.addEventListener('message', (e) => {
    const data = e.data as { type?: string } | null;
    if (data?.type !== CONSENT_REQUEST_MSG) return;
    if (e.origin !== window.location.origin && !ALLOWED_PARENTS.includes(e.origin)) return;
    const consent = getConsent();
    if (consent == null) return;
    try {
      (e.source as Window | null)?.postMessage({ type: CONSENT_MSG, consent }, e.origin);
    } catch {
      // ignore send errors
    }
  });
}
